export default "__VITE_ASSET__CeRpGH03__"